import { render, staticRenderFns } from "./template.html?vue&type=template&id=0dd1f2b4&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd1f2b4')) {
      api.createRecord('0dd1f2b4', component.options)
    } else {
      api.reload('0dd1f2b4', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=0dd1f2b4&", function () {
      api.rerender('0dd1f2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/vueGallery/components/LightBox.vue"
export default component.exports